
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post-sitemap.xml",
      function () {
        return require("private-next-pages/post-sitemap.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post-sitemap.xml"])
      });
    }
  